<mat-card class="example-card" *ngFor="let notification of notifications">
  <mat-card-header>
    <div mat-card-avatar class="readButton"><mat-icon aria-hidden="false" aria-label="notifica letta" fontIcon="visibility"></mat-icon></div>
    <mat-card-title>{{notification.Title}}</mat-card-title>
    <mat-card-subtitle>{{notification.CreatedAt | date:'dd/MM/yyyy - HH:mm' }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <p>{{notification.Body}}</p>
  </mat-card-content>
</mat-card>